import React from 'react';
import { useTranslation } from 'react-i18next';

import { ConfirmationDialog } from 'app/components';
import { translations } from 'locales/i18n';

interface CancelDialogProps {
  open: boolean;
  handleClose: () => void;
  onConfirm: () => void;
}

export const CancelDialog = ({ open, handleClose, onConfirm }: CancelDialogProps) => {
  const { t } = useTranslation();
  return (
    <ConfirmationDialog
      open={open}
      title={t(translations.pages.billingFinance.confirmationDialog.cancelTitle())}
      onClose={handleClose}
      onConfirm={onConfirm}
    >
      {t(translations.pages.billingFinance.confirmationDialog.cancelDialog())}
    </ConfirmationDialog>
  );
};
